import { useRef, useState } from 'react';

import type { ReactNode, RefObject } from 'react';

import { Flyout } from './components/Flyout';

import { useOnClickOutside } from 'components/hooks/useOnClickOutside';

interface FlyoutOptions {
  position: { top: number; left: number };
  children?: ReactNode;
}

export interface FlyoutHookResult {
  flyout: ReactNode;
  showFlyout: (options: FlyoutOptions) => void;
  hideFlyout: () => void;
  isVisible: boolean;
}

export const useFlyout = (): FlyoutHookResult => {
  const flyoutRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [options, setOptions] = useState<FlyoutOptions>({
    position: { top: 0, left: 0 },
    children: null,
  });

  const showFlyout = (customOptions: FlyoutOptions): void => {
    setVisible(true);
    setOptions({ ...options, ...customOptions });
  };

  const hideFlyout = (): void => {
    setVisible(false);
    setOptions({ ...options });
  };

  useOnClickOutside(flyoutRef as RefObject<HTMLElement>, hideFlyout);

  const flyout = (
    <Flyout visible={visible} position={options.position} ref={flyoutRef}>
      {options.children}
    </Flyout>
  );

  return {
    flyout,
    showFlyout,
    hideFlyout,
    isVisible: visible,
  };
};
